import axiosInstance from "utils/axios";

export const submitResponse = async (data) => {
  return axiosInstance
    .post("form-response/submit-response", data)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw new Error(err);
    });
};
